import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useTextFormattingDialogueStyles = makeStyles({
  containerWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: '282px',
    ...shorthands.padding(
      tokens.spacingVerticalL,
      tokens.spacingHorizontalNone
    ),
    ...shorthands.margin('-24px', '-16px'),
  },
  container: {
    width: '100%',
    ...shorthands.flex(1),
  },
  backButton: {
    justifyContent: 'flex-start',
    paddingLeft: 0,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    columnGap: tokens.spacingHorizontalXS,
    paddingBottom: tokens.spacingVerticalL,
  },
  content: {
    ...shorthands.padding(tokens.spacingVerticalNone, tokens.spacingHorizontalMNudge),
    paddingTop: tokens.spacingVerticalL,
  },
  fontSelectorHeader: {
    display: 'block',
    paddingBottom: tokens.spacingVerticalXS,
  },
  fontSelect: {
    minWidth: 'auto',
    maxWidth: '100%',
    '& > input': {
      maxWidth: '100%',
    },
  },
  fontWeightSelect: {
    minWidth: 'auto',
    maxWidth: '100%',
    '& > input': {
      maxWidth: '100%',
    },
  },
  fontContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(172px, 1fr))',
    gridGap: tokens.spacingHorizontalS,
  },
  contentDivider: {
    display: 'inline-flex',
    marginTop: tokens.spacingVerticalXL,
  },
});
